import { api } from './api';

export default async function fetchForecastGeneralData({
	accessToken,
	year,
	countryId,
	ownerId,
	offset,
	limit,
	search,
	marketplaceId,
}) {
	const res = await api.get('/GetForecastDataHistory', {
		params: {
			countryId,
			limit,
			offset,
			cmUserId: ownerId,
			year: year ? year : 0,
			sku: search !== '' ? search : undefined,
			marketplace_id: marketplaceId,
		},
		headers: {
			Authorization: `Bearer ${accessToken}`,
			accept: '*/*',
		},
	});

	const items = res?.data?.data || [];
	const count = res?.data?.count;

	return {
		items: items.map((item) => ({
			...item,
			id: `${item?.created_at}-${item?.country_id}-${item?.product_id}-${item?.category_id}-${item?.marketplace_id}`,
		})),
		count,
	};
}
